import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import axios from 'axios';

import serverURI from 'config/URI';

import { toast } from 'react-toastify';

import { 
  Button, 
  Dialog, 
  // DialogActions,
  // DialogContent,
  // DialogContentText,
  // ListItemText, 
  ListItem, 
  List, 
  Divider, 
  AppBar, 
  Toolbar, 
  IconButton, 
  Typography, 
  Slide,
  TextField,
  Card,
  CardHeader,
  // CardActions,
  CardContent,
  Box,
  // MenuItem,
  // Paper,
  // Tabs,
  // Tab,
  // GridList,
  // GridListTile,
  // GridListTileBar,
  // ListSubheader,
  // Table,
  // TableBody,
  // TableCell,
  // TableHead,
  // TableRow,
  // TablePagination,
  // Checkbox
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
// import InfoIcon from '@material-ui/icons/Info';

// import DateFnsUtils from '@date-io/date-fns';
// import krLocale from "date-fns/locale/ko";
// import {
//   MuiPickersUtilsProvider,
//   KeyboardTimePicker,
//   KeyboardDatePicker,
// } from '@material-ui/pickers';

// import { areas, groups, statusContracts, typesCompany } from 'common/datas';
import { IsNoU } from 'common/utils';

//import { StatusAdvertise, StatusBullet } from 'components';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  row: {
    height: '82px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  content: {
    marginTop: theme.spacing(2)
  },
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  card_header: {
    backgroundColor: theme.palette.card_header,
  },
  registerListItemTitle: {
    marginLeft: theme.spacing(2),
    width: '120px',
  },
  registerListItemInput: {
    //marginLeft: theme.spacing(2),
    width: '260px',
    //height: '40px',
  },
  registerListItemWideInput: {
    //marginLeft: theme.spacing(2),
    width: '480px',
    //height: '40px',
  },

  // gridList: {
  //   width: 500,
  //   height: 450,
  // },
  // icon: {
  //   color: 'rgba(255, 255, 255, 0.54)',
  // },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const RegisterAgency = props => {

  const {
    className,
    openDialog,
    modeRegisterDialog,
    onClickCloseDialog,
    onClickSaveDialog,

    companies,
    editAgency,
  } = props;

  const classes = useStyles();

  const [agencyName, setAgencyName] = useState('');

  const [manager, setManager] = useState('');
  const [telephone, setTelephone] = useState('');
  const [mobile, setMobile] = useState('');
  const [email, setEmail] = useState('');

  const [zipcode, setZipcode] = useState('');
  const [address1, setAddress1] = useState('');
  const [address2, setAddress2] = useState('');

  const handlePostcodeComplete = (data) => {
    //console.log(data);
    let fullAddress = data.address;
    let extraAddress = ''; 

    if (!IsNoU(data.zonecode)) {
      setZipcode(data.zonecode);
    }
    
    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname;
      }
      if (data.buildingName !== '') {
        extraAddress += (extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName);
      }
      fullAddress += (extraAddress !== '' ? ` (${extraAddress})` : '');
      setAddress1(fullAddress);
    }

    //console.log(fullAddress);  // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
  };

  const initializeDaum = () => {
    window.daum.postcode.load(() => {
      const Postcode = new window.daum.Postcode({
        oncomplete: function oncomplete(data) {
          handlePostcodeComplete(data);
          //if (comp.props.autoClose) comp.setState({ display: 'none' });
        },
        // onsearch: comp.props.onSearch,
        // onresize: function onresize(size) {
        //   if (comp.props.autoResize) comp.setState({ height: size.height });
        // },
        // alwaysShowEngAddr: comp.props.alwaysShowEngAddr,
        // animation: comp.props.animation,
        // autoMapping: comp.props.autoMapping,
        // autoResize: comp.props.autoResize,
        // height: comp.props.height,
        // hideEngBtn: comp.props.hideEngBtn,
        // hideMapBtn: comp.props.hideMapBtn,
        // maxSuggestItems: comp.props.maxSuggestItems,
        // pleaseReadGuide: comp.props.pleaseReadGuide,
        // pleaseReadGuideTimer: comp.props.pleaseReadGuideTimer,
        // shorthand: comp.props.shorthand,
        // showMoreHName: comp.props.showMoreHName,
        // submitMode: comp.props.submitMode,
        // theme: comp.props.theme,
        // useSuggest: comp.props.useSuggest,
        // width: comp.props.width,
        // focusInput: comp.props.focusInput,
        // focusContent: comp.props.focusContent,
      });

      Postcode.open();

      //Postcode.embed(this.wrap, { q: this.props.defaultQuery, autoClose: this.props.autoClose });
    });
  };

  const handleDaumError = (error) => {
    error.target.remove();
    //this.setState({ error: true });
    //console.log("err -> ");
  };

  const getCheckedAgency = (name) => {
    return axios({
      method: 'post',
      url: `${serverURI}/api/company/agency/check`,
      data: {
        name: name,
      }
    });
  }
  
  useEffect(() => {
    //console.log("componentDidMount");

    const scriptId = 'daum_postcode_script';
    const isExist = !!document.getElementById(scriptId);

    if (!isExist) {
      const script = document.createElement('script');
      script.src = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';//this.props.scriptUrl;
      script.onload = () => {};//initializeDaum();
      script.onerror = error => handleDaumError(error);
      script.id = scriptId;
      document.body.appendChild(script);
    } 
    else {
      //initializeDaum();
    }

    if (!IsNoU(editAgency))
    {
      setAgencyName(editAgency.name);

      setManager(editAgency.manager);
      setTelephone(editAgency.tel);
      setMobile(editAgency.mobile);
      setEmail(editAgency.email);

      setZipcode(editAgency.zipcode);
      setAddress1(editAgency.address1);
      setAddress2(editAgency.address2);
    }
    else {
      setAgencyName('');

      setManager('');
      setTelephone('');
      setMobile('');
      setEmail('');

      setZipcode('');
      setAddress1('');
      setAddress2('');
    }

  }, [editAgency]); // empty-array means don't watch for any updates

  // useEffect(() => {
  //   console.log("componentDidMount");

  //   if (!IsNoU(companies))
  //   {
  //     if (companies.length > 0)
  //       setSelectedCompany(companies[0]);
  //     else
  //       setSelectedCompany('');
  //   }

  // }, [companies]); // empty-array means don't watch for any updates

  return (
    <div>
      <Dialog fullScreen open={openDialog} onClose={onClickCloseDialog} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={onClickCloseDialog} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h5" className={classes.title} color="inherit">
              광고대행사 {modeRegisterDialog ? '등록' : '수정'}
            </Typography>
            <Button autoFocus color="inherit" onClick={async () => {

                if (IsNoU(agencyName) || agencyName.length <= 0) {
                  toast("광고대행사명을 입력하세요.");
                  return ;
                }

                const res = await getCheckedAgency(agencyName);
                //console.log(res);
                const checked_agency = res.data.checked_agency;
                if (!checked_agency) {
                  toast(agencyName+" 광고대행사가 존재합니다..");
                  return ;
                }

                const newAgency = {
                  name: agencyName,
                  manager: manager,
                  tel: telephone,
                  mobile: mobile,
                  email: email,
                  zipcode: zipcode,
                  address1: address1,
                  address2: address2,
                  reg_at: new Date(),
                };

                if (!IsNoU(editAgency))
                  newAgency.id = editAgency.id;

                onClickSaveDialog(newAgency);
              }}>
              저장
            </Button>
          </Toolbar>
        </AppBar>

        <List>
          <ListItem>
            <Card
              className={clsx(classes.card_root, className)}
            >
              <CardHeader
                className={classes.card_header}
                title={modeRegisterDialog ? '광고대행사 등록' : '광고대행사 수정'}
                subheader='*표시는 필수 항목'
              />
              <CardContent className={classes.content}>
                <List>
                  <ListItem className={classes.listitem_align}>
                    <TextField 
                      className={classes.registerListItemInput}
                      id="outlined-basic-reg-agency-name"
                      label="광고대행사명"
                      required
                      //variant="outlined" 
                      value={agencyName}
                      onChange={event=> setAgencyName(event.target.value)}
                      margin="dense"/>
                    
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <TextField 
                      className={classes.registerListItemInput}
                      id="outlined-basic-reg-agency-manager"
                      label="거래담당자"
                      //variant="outlined" 
                      value={manager}
                      onChange={event=> setManager(event.target.value)}
                      margin="dense"/>

                    <Box p={2} />

                    <TextField 
                      className={classes.registerListItemInput}
                      id="outlined-basic-reg-agency-phone"
                      label="전화번호"
                      //variant="outlined" 
                      value={telephone}
                      onChange={event=> setTelephone(event.target.value)}
                      margin="dense"/>

                    <Box p={2} />

                    <TextField 
                      className={classes.registerListItemInput}
                      id="outlined-basic-reg-agency-mobile"
                      label="핸드폰"
                      //variant="outlined" 
                      value={mobile}
                      onChange={event=> setMobile(event.target.value)}
                      margin="dense"/>
                  </ListItem>
                  <ListItem>
                    <Typography
                      className={classes.registerListItemInput}
                      color="textSecondary"
                      gutterBottom
                    >
                    </Typography>

                    <Box p={2} />

                    <TextField 
                      className={classes.registerListItemWideInput}
                      id="outlined-basic-reg-agency-email"
                      label="메일"
                      //variant="outlined" 
                      value={email}
                      onChange={event=> setEmail(event.target.value)}
                      margin="dense"/>
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <TextField 
                      className={classes.registerListItemInput}
                      id="outlined-basic-reg-agency-zipcode"
                      label="우편번호"
                      //variant="outlined" 
                      value={zipcode}
                      onChange={event=> setZipcode(event.target.value)}
                      margin="dense"/>
                    <Box p={2} />
                    <Button
                      variant="contained"
                      onClick={ () => initializeDaum() }
                    >
                      우편번호 찾기
                    </Button>

                  </ListItem>
                  <ListItem>
                    <TextField 
                      className={classes.registerListItemWideInput}
                      id="outlined-basic-reg-agency-address1"
                      label="주소"
                      //variant="outlined" 
                      value={address1}
                      onChange={event=> setAddress1(event.target.value)}
                      margin="dense"/>
                  </ListItem>

                  <ListItem>
                    <TextField 
                      className={classes.registerListItemWideInput}
                      id="outlined-basic-reg-agency-address2"
                      label="상세 주소"
                      //variant="outlined" 
                      value={address2}
                      onChange={event=> setAddress2(event.target.value)}
                      margin="dense"/>
                  </ListItem>
                  <Divider />
                </List>
              </CardContent>
            </Card>
          </ListItem>
        </List>
      </Dialog>
    </div>
  );
}

RegisterAgency.propTypes = {
  className: PropTypes.string,
  companies: PropTypes.array.isRequired,
};

RegisterAgency.defaultProps = {
  companies: [],
};


export default RegisterAgency;
